import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9c51bba4 = () => interopDefault(import('../client/pages/cart/index.vue' /* webpackChunkName: "" */))
const _1710a2bc = () => interopDefault(import('../client/pages/products/no-minimum/_.vue' /* webpackChunkName: "" */))
const _3f074814 = () => interopDefault(import('../client/pages/products/closeout/_.vue' /* webpackChunkName: "" */))
const _f5656796 = () => interopDefault(import('../client/pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _a83e30a4 = () => interopDefault(import('../client/pages/cartitemsadded/index.vue' /* webpackChunkName: "pages/cartitemsadded/index" */))
const _0144104e = () => interopDefault(import('../client/pages/changepassword/index.vue' /* webpackChunkName: "pages/changepassword/index" */))
const _3e216fca = () => interopDefault(import('../client/pages/customer-artwork-proof/index.vue' /* webpackChunkName: "pages/customer-artwork-proof/index" */))
const _26390306 = () => interopDefault(import('../client/pages/designs/index.vue' /* webpackChunkName: "pages/designs/index" */))
const _d50d662c = () => interopDefault(import('../client/pages/facets/index.vue' /* webpackChunkName: "pages/facets/index" */))
const _fb012ec2 = () => interopDefault(import('../client/pages/favorites/index.vue' /* webpackChunkName: "pages/favorites/index" */))
const _490a1ee8 = () => interopDefault(import('../client/pages/forgotpassword/index.vue' /* webpackChunkName: "pages/forgotpassword/index" */))
const _935b7f32 = () => interopDefault(import('../client/pages/health.vue' /* webpackChunkName: "pages/health" */))
const _76230110 = () => interopDefault(import('../client/pages/not-found/index.vue' /* webpackChunkName: "pages/not-found/index" */))
const _b9027c68 = () => interopDefault(import('../client/pages/proof/index.vue' /* webpackChunkName: "pages/proof/index" */))
const _2e17cc68 = () => interopDefault(import('../client/pages/proofitemsadded/index.vue' /* webpackChunkName: "pages/proofitemsadded/index" */))
const _15a679f8 = () => interopDefault(import('../client/pages/quoteitemsadded/index.vue' /* webpackChunkName: "pages/quoteitemsadded/index" */))
const _621b061c = () => interopDefault(import('../client/pages/resetpassword/index.vue' /* webpackChunkName: "pages/resetpassword/index" */))
const _05f8f878 = () => interopDefault(import('../client/pages/sampleitemsadded/index.vue' /* webpackChunkName: "pages/sampleitemsadded/index" */))
const _f494a920 = () => interopDefault(import('../client/pages/signin/index.vue' /* webpackChunkName: "pages/signin/index" */))
const _c1f94d0e = () => interopDefault(import('../client/pages/signout/index.vue' /* webpackChunkName: "pages/signout/index" */))
const _c7538b22 = () => interopDefault(import('../client/pages/suppliers/index.vue' /* webpackChunkName: "pages/suppliers/index" */))
const _7608ed72 = () => interopDefault(import('../client/pages/test-page/index.vue' /* webpackChunkName: "pages/test-page/index" */))
const _ffb27222 = () => interopDefault(import('../client/pages/testy/index.vue' /* webpackChunkName: "pages/testy/index" */))
const _9cc48f46 = () => interopDefault(import('../client/pages/version.vue' /* webpackChunkName: "pages/version" */))
const _02189f18 = () => interopDefault(import('../client/pages/version-app/index.vue' /* webpackChunkName: "pages/version-app/index" */))
const _65f74ea0 = () => interopDefault(import('../client/pages/cat/GeneralProductView.vue' /* webpackChunkName: "pages/cat/GeneralProductView" */))
const _1a3c5dd4 = () => interopDefault(import('../client/pages/orders/products/index.vue' /* webpackChunkName: "pages/orders/products/index" */))
const _1bc1ef1e = () => interopDefault(import('../client/pages/products/utils.js' /* webpackChunkName: "pages/products/utils" */))
const _7d3c83e5 = () => interopDefault(import('../client/pages/products/search/mixin.js' /* webpackChunkName: "pages/products/search/mixin" */))
const _5294a320 = () => interopDefault(import('../client/pages/products/search/search.js' /* webpackChunkName: "pages/products/search/search" */))
const _c4f041ce = () => interopDefault(import('../client/pages/sso/facebook/delete.vue' /* webpackChunkName: "pages/sso/facebook/delete" */))
const _289b35c2 = () => interopDefault(import('../client/pages/sso/punch-out/_source.vue' /* webpackChunkName: "pages/sso/punch-out/_source" */))
const _5bc8cf83 = () => interopDefault(import('../client/pages/review/order/_orderId/product/_productId.vue' /* webpackChunkName: "pages/review/order/_orderId/product/_productId" */))
const _b877e870 = () => interopDefault(import('../client/pages/products/search/_.vue' /* webpackChunkName: "pages/products/search/_" */))
const _cc871c78 = () => interopDefault(import('../client/pages/blog/cat/_.vue' /* webpackChunkName: "pages/blog/cat/_" */))
const _d5d95ec4 = () => interopDefault(import('../client/pages/approval/_orderId/index.vue' /* webpackChunkName: "pages/approval/_orderId/index" */))
const _02c22551 = () => interopDefault(import('../client/pages/artproof/_productSlug/index.vue' /* webpackChunkName: "pages/artproof/_productSlug/index" */))
const _6ea82b54 = () => interopDefault(import('../client/pages/authors/_authorName/index.vue' /* webpackChunkName: "pages/authors/_authorName/index" */))
const _352f295a = () => interopDefault(import('../client/pages/components/_componentId/index.vue' /* webpackChunkName: "pages/components/_componentId/index" */))
const _953f2e6e = () => interopDefault(import('../client/pages/configureproduct/_productSlug/index.vue' /* webpackChunkName: "pages/configureproduct/_productSlug/index" */))
const _386cd496 = () => interopDefault(import('../client/pages/customer-artwork-proof/_id/index.vue' /* webpackChunkName: "pages/customer-artwork-proof/_id/index" */))
const _b0e95832 = () => interopDefault(import('../client/pages/designer/_productSlug/index.vue' /* webpackChunkName: "pages/designer/_productSlug/index" */))
const _ba6c3010 = () => interopDefault(import('../client/pages/designs/_slug/index.vue' /* webpackChunkName: "pages/designs/_slug/index" */))
const _dd571eb6 = () => interopDefault(import('../client/pages/facets/_slug/index.vue' /* webpackChunkName: "pages/facets/_slug/index" */))
const _d390129e = () => interopDefault(import('../client/pages/largequote/_productSlug/index.vue' /* webpackChunkName: "pages/largequote/_productSlug/index" */))
const _9bc5df44 = () => interopDefault(import('../client/pages/orders/_id/index.vue' /* webpackChunkName: "pages/orders/_id/index" */))
const _8d28c918 = () => interopDefault(import('../client/pages/payments/_orderId/index.vue' /* webpackChunkName: "pages/payments/_orderId/index" */))
const _5b1ef832 = () => interopDefault(import('../client/pages/presentation/_orderId/index.vue' /* webpackChunkName: "pages/presentation/_orderId/index" */))
const _c8bc0768 = () => interopDefault(import('../client/pages/presentations/_id/index.vue' /* webpackChunkName: "pages/presentations/_id/index" */))
const _7a472d61 = () => interopDefault(import('../client/pages/printinvoice/_orderId/index.vue' /* webpackChunkName: "pages/printinvoice/_orderId/index" */))
const _215300a6 = () => interopDefault(import('../client/pages/products/_slug/index.vue' /* webpackChunkName: "pages/products/_slug/index" */))
const _536bd292 = () => interopDefault(import('../client/pages/proof/_id/index.vue' /* webpackChunkName: "pages/proof/_id/index" */))
const _2f9d7b3a = () => interopDefault(import('../client/pages/quickquote/_productSlug/index.vue' /* webpackChunkName: "pages/quickquote/_productSlug/index" */))
const _598a1aee = () => interopDefault(import('../client/pages/reorder/_id/index.vue' /* webpackChunkName: "pages/reorder/_id/index" */))
const _213b74f0 = () => interopDefault(import('../client/pages/sample/_productSlug/index.vue' /* webpackChunkName: "pages/sample/_productSlug/index" */))
const _01777041 = () => interopDefault(import('../client/pages/sso/_service.vue' /* webpackChunkName: "pages/sso/_service" */))
const _48948e0e = () => interopDefault(import('../client/pages/cat/_slug/brand.vue' /* webpackChunkName: "pages/cat/_slug/brand" */))
const _0531f783 = () => interopDefault(import('../client/pages/orders/_id/track-shipment/index.vue' /* webpackChunkName: "pages/orders/_id/track-shipment/index" */))
const _3187a40b = () => interopDefault(import('../client/pages/printinvoice/_orderId/short.vue' /* webpackChunkName: "pages/printinvoice/_orderId/short" */))
const _969f8c94 = () => interopDefault(import('../client/pages/products/_slug/reviews.vue' /* webpackChunkName: "pages/products/_slug/reviews" */))
const _5925f990 = () => interopDefault(import('../client/pages/facets/_slug/_facet/index.vue' /* webpackChunkName: "pages/facets/_slug/_facet/index" */))
const _01135307 = () => interopDefault(import('../client/pages/supplier/_psCode/_.vue' /* webpackChunkName: "pages/supplier/_psCode/_" */))
const _76292666 = () => interopDefault(import('../client/pages/cat/_slug/_.vue' /* webpackChunkName: "pages/cat/_slug/_" */))
const _6626f624 = () => interopDefault(import('../client/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/box/cart",
    component: _9c51bba4,
    name: "box/cart"
  }, {
    path: "/quote/cart",
    component: _9c51bba4,
    name: "quote/cart"
  }, {
    path: "/sample/cart",
    component: _9c51bba4,
    name: "sample/cart"
  }, {
    path: "/proof/cart",
    component: _9c51bba4,
    name: "proof/cart"
  }, {
    path: "/boxcart",
    component: _9c51bba4,
    name: "boxcart"
  }, {
    path: "/quotecart",
    component: _9c51bba4,
    name: "quotecart"
  }, {
    path: "/samplecart",
    component: _9c51bba4,
    name: "samplecart"
  }, {
    path: "/proofcart",
    component: _9c51bba4,
    name: "proofcart"
  }, {
    path: "/products/no-minimum",
    component: _1710a2bc,
    name: "products-no-minimum"
  }, {
    path: "/products/closeout",
    component: _3f074814,
    name: "products-closeout"
  }, {
    path: "/account",
    component: _f5656796,
    name: "account"
  }, {
    path: "/cart",
    component: _9c51bba4,
    name: "cart"
  }, {
    path: "/cartitemsadded",
    component: _a83e30a4,
    name: "cartitemsadded"
  }, {
    path: "/changepassword",
    component: _0144104e,
    name: "changepassword"
  }, {
    path: "/customer-artwork-proof",
    component: _3e216fca,
    name: "customer-artwork-proof"
  }, {
    path: "/designs",
    component: _26390306,
    name: "designs"
  }, {
    path: "/facets",
    component: _d50d662c,
    name: "facets"
  }, {
    path: "/favorites",
    component: _fb012ec2,
    name: "favorites"
  }, {
    path: "/forgotpassword",
    component: _490a1ee8,
    name: "forgotpassword"
  }, {
    path: "/health",
    component: _935b7f32,
    name: "health"
  }, {
    path: "/not-found",
    component: _76230110,
    name: "not-found"
  }, {
    path: "/proof",
    component: _b9027c68,
    name: "proof"
  }, {
    path: "/proofitemsadded",
    component: _2e17cc68,
    name: "proofitemsadded"
  }, {
    path: "/quoteitemsadded",
    component: _15a679f8,
    name: "quoteitemsadded"
  }, {
    path: "/resetpassword",
    component: _621b061c,
    name: "resetpassword"
  }, {
    path: "/sampleitemsadded",
    component: _05f8f878,
    name: "sampleitemsadded"
  }, {
    path: "/signin",
    component: _f494a920,
    name: "signin"
  }, {
    path: "/signout",
    component: _c1f94d0e,
    name: "signout"
  }, {
    path: "/suppliers",
    component: _c7538b22,
    name: "suppliers"
  }, {
    path: "/test-page",
    component: _7608ed72,
    name: "test-page"
  }, {
    path: "/testy",
    component: _ffb27222,
    name: "testy"
  }, {
    path: "/version",
    component: _9cc48f46,
    name: "version"
  }, {
    path: "/version-app",
    component: _02189f18,
    name: "version-app"
  }, {
    path: "/cat/GeneralProductView",
    component: _65f74ea0,
    name: "cat-GeneralProductView"
  }, {
    path: "/orders/products",
    component: _1a3c5dd4,
    name: "orders-products"
  }, {
    path: "/products/utils",
    component: _1bc1ef1e,
    name: "products-utils"
  }, {
    path: "/products/search/mixin",
    component: _7d3c83e5,
    name: "products-search-mixin"
  }, {
    path: "/products/search/search",
    component: _5294a320,
    name: "products-search-search"
  }, {
    path: "/sso/facebook/delete",
    component: _c4f041ce,
    name: "sso-facebook-delete"
  }, {
    path: "/sso/punch-out/:source?",
    component: _289b35c2,
    name: "sso-punch-out-source"
  }, {
    path: "/review/order/:orderId?/product/:productId?",
    component: _5bc8cf83,
    name: "review-order-orderId-product-productId"
  }, {
    path: "/products/search/*",
    component: _b877e870,
    name: "products-search-all"
  }, {
    path: "/products/no-minimum/*",
    component: _1710a2bc,
    name: "products-no-minimum-all"
  }, {
    path: "/products/closeout/*",
    component: _3f074814,
    name: "products-closeout-all"
  }, {
    path: "/blog/cat/*",
    component: _cc871c78,
    name: "blog-cat-all"
  }, {
    path: "/approval/:orderId",
    component: _d5d95ec4,
    name: "approval-orderId"
  }, {
    path: "/artproof/:productSlug",
    component: _02c22551,
    name: "artproof-productSlug"
  }, {
    path: "/authors/:authorName",
    component: _6ea82b54,
    name: "authors-authorName"
  }, {
    path: "/components/:componentId",
    component: _352f295a,
    name: "components-componentId"
  }, {
    path: "/configureproduct/:productSlug",
    component: _953f2e6e,
    name: "configureproduct-productSlug"
  }, {
    path: "/customer-artwork-proof/:id",
    component: _386cd496,
    name: "customer-artwork-proof-id"
  }, {
    path: "/designer/:productSlug",
    component: _b0e95832,
    name: "designer-productSlug"
  }, {
    path: "/designs/:slug",
    component: _ba6c3010,
    name: "designs-slug"
  }, {
    path: "/facets/:slug",
    component: _dd571eb6,
    name: "facets-slug"
  }, {
    path: "/largequote/:productSlug",
    component: _d390129e,
    name: "largequote-productSlug"
  }, {
    path: "/orders/:id",
    component: _9bc5df44,
    name: "orders-id"
  }, {
    path: "/payments/:orderId",
    component: _8d28c918,
    name: "payments-orderId"
  }, {
    path: "/presentation/:orderId",
    component: _5b1ef832,
    name: "presentation-orderId"
  }, {
    path: "/presentations/:id",
    component: _c8bc0768,
    name: "presentations-id"
  }, {
    path: "/printinvoice/:orderId",
    component: _7a472d61,
    name: "printinvoice-orderId"
  }, {
    path: "/products/:slug",
    component: _215300a6,
    name: "products-slug"
  }, {
    path: "/proof/:id",
    component: _536bd292,
    name: "proof-id"
  }, {
    path: "/quickquote/:productSlug",
    component: _2f9d7b3a,
    name: "quickquote-productSlug"
  }, {
    path: "/reorder/:id",
    component: _598a1aee,
    name: "reorder-id"
  }, {
    path: "/sample/:productSlug",
    component: _213b74f0,
    name: "sample-productSlug"
  }, {
    path: "/sso/:service?",
    component: _01777041,
    name: "sso-service"
  }, {
    path: "/cat/:slug?/brand",
    component: _48948e0e,
    name: "cat-slug-brand"
  }, {
    path: "/orders/:id?/track-shipment",
    component: _0531f783,
    name: "orders-id-track-shipment"
  }, {
    path: "/printinvoice/:orderId?/short",
    component: _3187a40b,
    name: "printinvoice-orderId-short"
  }, {
    path: "/products/:slug?/reviews",
    component: _969f8c94,
    name: "products-slug-reviews"
  }, {
    path: "/facets/:slug/:facet",
    component: _5925f990,
    name: "facets-slug-facet"
  }, {
    path: "/supplier/:psCode?/*",
    component: _01135307,
    name: "supplier-psCode-all"
  }, {
    path: "/cat/:slug?/*",
    component: _76292666,
    name: "cat-slug-all"
  }, {
    path: "/*",
    component: _6626f624,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
